class VaillantMediaGrid extends HTMLElement {
  connectedCallback() {
    this.cards = [...this.querySelectorAll('[data-media-grid-item]')];
    this.cards.forEach((card) => this.initializeCard(card));
  }

  initializeCard(card) {
    const loadTargets = [...card.querySelectorAll('.media-grid-vaillant__image, .media-grid-vaillant__poster')];

    if (!loadTargets.length) {
      card.classList.add('is-loaded');
    } else {
      loadTargets.forEach((target) => {
        if (target.complete && target.naturalWidth > 0) {
          card.classList.add('is-loaded');
          return;
        }

        target.addEventListener('load', () => card.classList.add('is-loaded'), { once: true });
        target.addEventListener('error', () => card.classList.add('is-loaded'), { once: true });
      });
    }

    const playButton = card.querySelector('[data-media-play]');
    const video = card.querySelector('video[data-lazy-video]');
    if (!playButton || !video) return;

    playButton.addEventListener('click', () => this.playVideo(card, video, playButton));

    video.addEventListener('play', () => {
      card.classList.add('is-playing', 'is-loaded');
      playButton.setAttribute('aria-pressed', 'true');
    });

    const showPlayButton = () => {
      card.classList.remove('is-playing');
      playButton.setAttribute('aria-pressed', 'false');
    };

    video.addEventListener('pause', showPlayButton);
    video.addEventListener('ended', showPlayButton);
    video.addEventListener('click', () => {
      if (video.paused) {
        this.playVideo(card, video, playButton);
      } else {
        video.pause();
      }
    });
  }

  playVideo(card, video, playButton) {
    if (!video.dataset.hydrated) {
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.hydrated = 'true';
      video.load();
    }

    const playPromise = video.play();
    if (playPromise) {
      playPromise.catch(() => {
        card.classList.remove('is-playing');
        playButton.setAttribute('aria-pressed', 'false');
      });
    }
  }
}

if (!customElements.get('vaillant-media-grid')) {
  customElements.define('vaillant-media-grid', VaillantMediaGrid);
}
